import { z } from "zod";

export const editModuleSchema = z.object({
    name: z.string().min(1, " اسم الكورس مطلوب"),
    overview: z.string().min(1, " وصف الكورس مطلوب"),
    price: z.string().optional(),
  });
  